import { render } from "./ClockOutline.vue?vue&type=template&id=1a84e403"
import script from "./ClockOutline.vue?vue&type=script&lang=js"
export * from "./ClockOutline.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__